var render, staticRenderFns
import script from "./LoginDYZ.vue?vue&type=script&lang=js"
export * from "./LoginDYZ.vue?vue&type=script&lang=js"
import style0 from "./LoginDYZ.vue?vue&type=style&index=0&id=b1040ff8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1040ff8",
  null
  
)

export default component.exports